import { SVGProps, FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Dashboard, Project } from '@sib/ui/icons';
import { paths } from '@sidecar/config/paths';

export interface SidebarMenuItem {
  href: string;
  title: string;
  icon: FC<SVGProps<SVGSVGElement>>;
  onClick?: () => void;
  hasExpandSubmenuArrow?: boolean;
  onExpandSubmenuClick?: () => void;
  isExpandedSubmenu?: boolean;
}

export const useSidebarItems = (): SidebarMenuItem[] => {
  const { t } = useTranslation();

  return [
    {
      href: paths.dashboard,
      title: t('sidebar.dashboard'),
      icon: Dashboard,
    },
    {
      href: paths.projects.root,
      title: t('sidebar.projects'),
      icon: Project,
      hasExpandSubmenuArrow: true,
    },
  ];
};
